import { SOW } from "../Action";

const HeaderData = [
  { name: "Unique ID", direction: "asc", sort: false, minWidth: "100px" },
  { name: "Req ID", direction: "asc", sort: true, key: "req_id.keyword" },
  { name: "Title", direction: "asc", sort: true, key: "job_title.keyword" },
  { name: "Status", direction: "asc", sort: false },
  {
    name: "Compensation (Hourly / Annual)",
    direction: "asc",
    sort: false,
    minWidth: "130px",
  },
  { name: "Client", direction: "asc", sort: true, key: "company_name.keyword" },
  {
    name: "Created",
    direction: "desc",
    sort: true,
    minWidth: "130px",
    key: "created_at",
  },
  {},
];
const intialState = {
  sowEnrich: {
    data: [],
    files: [],
    status: "",
  },
  sowJudicaFilter: {
    filter: {},
    pagination: 1,
    headerData: HeaderData,
    columnName: "",
    direction: "",
    status: false,
    search: "",
  },
};
const IgniteReducer = (state = intialState, action) => {
  switch (action.type) {
    case SOW.sowEnrich:
      return {
        ...state,
        sowEnrich: {
          data: action.data,
          files: action.data.files,
          status: action.data.status,
        },
      };
    case SOW.sowJudicaFilter:
      return { ...state, sowJudicaFilter: action.data };
    default:
      return state;
  }
};
export default IgniteReducer;
